var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8A92B2",
    d: "M959.8 80.7 420.1 976.3 959.8 731z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#62688F",
    d: "M959.8 731 420.1 976.3l539.7 319.1zM1499.6 976.3 959.8 80.7V731z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#454A75",
    d: "m959.8 1295.4 539.8-319.1L959.8 731z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A92B2",
    d: "m420.1 1078.7 539.7 760.6v-441.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#62688F",
    d: "M959.8 1397.6v441.7l540.1-760.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.5a5de20bf3808241fc61ed9ad7680ab5.svg";
export { ForwardRef as ReactComponent };